import LwcStringField from '~/forms/fields/lwc-string-field'

/**
 * "amount" field factory.
 * @returns {LwcStringField}
 */
export default function amountRecipe () {
  return new LwcStringField({
    required: true,
    type: 'Number',
  })
}
